import { c as _c } from "react/compiler-runtime";
export interface AuthorCardNameProps {
  name: string;
}
const AuthorCardName = props => {
  const $ = _c(2);
  const {
    name
  } = props;
  const t0 = name ?? "";
  let t1;
  if ($[0] !== t0) {
    t1 = <span className="font-work-sans text-base font-semibold leading-[135%] text-[#373B37]">{t0}</span>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default AuthorCardName;